module.exports = __webpack_public_path__ + "static/img/LC.409670b0.png";